module.exports = __webpack_public_path__ + "img/down-arrow.f18813e0.png";